import { AppNav, AppNavItemKeys } from '@shared/models/config';

interface RouteObject {
  readonly [key: string]: RouteValue;
}

type RouteFn = (...args: any[]) => string;

type RouteValue = string | RouteFn | RouteObject;

const ignoredKeys = ['listDefault'];

export function generateRoutePaths(routeNode: RouteValue, basePath = '', routesList: string[] = []): string[] {
  if (typeof routeNode === 'string') {
    if (routeNode) {
      routesList.push(basePath + routeNode);
    }
  }

  if (typeof routeNode === 'object') {
    let currentPath = basePath;
    if (typeof routeNode.root === 'string') {
      currentPath = routeNode.root;
    } else if (typeof routeNode.rootPath === 'string') {
      currentPath = routeNode.rootPath;
    }

    Object.keys(routeNode).forEach((key) => {
      if (ignoredKeys.includes(key)) {
        return;
      }

      const childNode = routeNode[key as keyof typeof routeNode];

      if (childNode) {
        let newBasePath = basePath;
        if (key !== 'root' && key !== 'rootPath') {
          newBasePath = currentPath;
        }
        generateRoutePaths(childNode, newBasePath, routesList);
      }
    });
  }

  return routesList;
}

export const getDefaultPath = (appUrl: string, appNav: AppNav) => {
  const defaultPageItem = appNav[appNav.default_page as AppNavItemKeys];
  const defaultUrl = defaultPageItem?.url ?? '/';

  return getTransformedRoute(appUrl, defaultUrl);
};

export const getTransformedRoute = (appUrl: string, url: string): string => {
  let transformedUrl = url;

  if (transformedUrl.startsWith(appUrl)) {
    transformedUrl = transformedUrl.slice(appUrl.length);
  }

  transformedUrl = transformedUrl.replace('/atlas-rankings', '/atlas-data');

  return transformedUrl;
};

export const generateUrlId = (url: string) => {
  // Strip url prefixes
  if (url.includes('://')) {
    // Strip any protocols, i.e. keep after ://
    url = url.split('://')[1] ?? '';

    // Strip anything before first slash
    if (url.includes('/')) {
      url = url.split('/').slice(1).join('/');
    }
  }

  // Remove hash
  if (url.includes('#')) {
    url = url.split('#')[1] ?? '';
  }

  // Remove query string
  if (url.includes('?')) {
    url = url.split('?')[0] ?? '';
  }

  // Replace - with _
  url = url.replace(/-/g, '_');

  const chunks = url.split('/').reduce((result, chunk) => {
    const parsedNumber = parseInt(chunk, 10);

    if (chunk && isNaN(parsedNumber)) {
      // Not a number, must be a string
      result.push(chunk);
    } else if (chunk) {
      // Valid number, push id
      result.push('id');
    }

    return result;
  }, [] as string[]);

  return chunks.join('_');
};
